import React from "react";

export default function Header({ subtitle }) {
  return (
    <header className="site-header">
      <div className="logo-wrap">
        <img
          src="https://hyperdigitech.com/assets/logo-De65uxdz.webp"
          alt="HyperDigiTech"
          onError={(e) => {
            e.target.style.display = "none";
            e.target.nextSibling.style.display = "block";
          }}
        />
        <span style={{ display: "none", fontFamily: "'Poppins',sans-serif", fontWeight: 800, fontSize: "1.1rem", background: "linear-gradient(135deg,#00d4ff,#7c3aed)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent" }}>
          HyperDigiTech
        </span>
      </div>
      {subtitle && <span className="header-badge">{subtitle}</span>}
    </header>
  );
}